import { LanguageSwitcher } from '@shared/components/LanguageSwitcher';
import Logo from '@shared/components/Logo';
import { ModeToggle } from '@shared/components/ModeToggle';
import { Button } from "@shared/components/ui/button";
import { useSettings } from '@shared/contexts/SettingContext';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AuthLayout = ({ children }) => {
  const { settings } = useSettings();
  const { t } = useTranslation();

  return (
    <>
      <div className="grid min-h-screen md:grid-cols-2">
        {/* Left Section */}
        <div className="relative hidden md:flex">
          <div className="absolute inset-0 bg-[url('/images/auth-background.jpg')] bg-cover bg-center" />
          <div className="relative z-10 flex h-full w-full flex-col justify-between bg-black/60 p-10 text-white">
            <div className="flex items-center gap-2">
              <Logo className={"h-14 p-0"} />
            </div>
            <div className="space-y-4">
              <p className="text-lg">
                {settings?.siteDescription || "The Best Delivery Company"}
              </p>
              <Button>{t("auth.learnMore")}</Button>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex flex-col p-8">
          <div className="flex justify-end">
            <div className="flex items-center gap-4">
              <LanguageSwitcher />
              <ModeToggle />
            </div>
          </div>
          <div className="mx-auto flex w-full flex-col justify-center space-y-6">
            {children}
            <p className="px-8 text-center text-sm text-muted-foreground">
              {t("auth.byClickingContinue")}{" "}
              <Link
                to="/terms"
                className="underline underline-offset-4 hover:text-primary"
              >
                {t("auth.termsOfService")}
              </Link>{" "}
              {t("auth.and")}{" "}
              <Link
                to="/privacy"
                className="underline underline-offset-4 hover:text-primary"
              >
                {t("auth.privacyPolicy")}
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
